module.exports = __webpack_public_path__ + "static/features-bg-5aa05c64a6a457f725b1874df314b653.png";